import { render } from "./menu-drawer.vue?vue&type=template&id=4abd42c4"
import script from "./menu-drawer.vue?vue&type=script&lang=js"
export * from "./menu-drawer.vue?vue&type=script&lang=js"

import "./menu-drawer.vue?vue&type=style&index=0&id=4abd42c4&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__